/* Discount Caskets live chat widget.
   Config comes from data- attributes on #live-chat-root (see snippets/live-chat.liquid).
   All server output is treated as untrusted: bubbles are built with
   createElement/textContent only — never innerHTML. */
(function () {
  'use strict';
  if (window.__dcChatLoaded) return;
  window.__dcChatLoaded = true;

  function boot() {
    var root = document.getElementById('live-chat-root');
    if (!root) return;

    var ENDPOINT = root.dataset.endpoint || 'https://chat.discount-caskets.com/chat.php';
    var PHONE = root.dataset.phone || '(888) 985-9255';
    var TITLE = root.dataset.title || 'Discount Caskets';

    var POLL_ENDPOINT = (root.dataset.endpoint || 'https://chat.discount-caskets.com/chat.php')
      .replace(/chat\.php$/, 'poll.php');
    var AGENT_SEEN_KEY = 'dcChatAgentSeen';
    var agentPollTimer = null;

    /* How far through the agent's messages this visitor has got.

       This MUST be persisted. It used to be a plain variable, which was fine
       until the agent used Forward: applying a navigate action reloads the
       page, the counter reset to 0, the next poll returned the same navigate
       action, and the page navigated again — a reload loop once a second that
       the visitor could not escape. It survives navigation now, so a delivered
       action is never delivered twice. */
    var agentLastId = (function () {
      var v = parseInt(readStore(AGENT_SEEN_KEY) || '0', 10);
      return isNaN(v) ? 0 : v;
    })();
    function markAgentSeen(id) {
      if (id > agentLastId) {
        agentLastId = id;
        try { writeStore(AGENT_SEEN_KEY, String(id)); } catch (e) {}
      }
    }

    /* Takeover polling.

       The assistant replies inside the same request the customer's message
       made. A person cannot: they take time to type, and they often speak
       first. So while a session is in agent mode the widget asks poll.php what
       the agent has said since the last line it showed.

       Polling rather than SSE or a socket: LiteSpeed in front of this host will
       not proxy WebSockets, and holding an SSE connection open per visitor is a
       lot of server for a shop talking to a handful of people at once. Five
       seconds sits inside human typing latency, and it stops itself once the
       agent hands back so an idle tab is not polling forever. */
    var agentPollMs = 0;

    /* Poll for as long as there is a conversation, not only after the customer
       speaks.

       The first version started polling from the reply to a customer message,
       so an agent who took over and typed first was talking into the void: the
       widget was not listening, and nothing appeared until the customer
       happened to send something else. Taking over IS the moment someone needs
       to be heard, so listening cannot depend on the customer's next keystroke.

       Slow while the assistant is handling it — enough to notice a takeover —
       and quick once a human is on. Paused while the tab is hidden so a
       forgotten background tab is not polling all day. */
    function startAgentPolling(ms) {
      var want = ms || 12000;
      if (agentPollTimer && agentPollMs === want) return;
      if (agentPollTimer) clearInterval(agentPollTimer);
      agentPollMs = want;
      agentPollTimer = setInterval(pollAgent, want);
      pollAgent();
    }
    function stopAgentPolling() {
      if (agentPollTimer) { clearInterval(agentPollTimer); agentPollTimer = null; agentPollMs = 0; }
    }
    /* The same poll carries a heartbeat: the page being read now, and the
       sentence still being typed. An agent watching a live chat sees the
       visitor move around the site and can start on the answer before the
       question lands, instead of learning where they were only when they sent
       something.

       The draft is sent only while the panel is open and only as far as this
       server: it overwrites one column, is cleared on send, never joins the
       transcript, and the console treats it as stale after a few seconds. */
    var lastDraftSent = null;
    function draftNow() {
      if (!isOpen || !input) return null;
      var v = (input.value || '').trim().slice(0, 160);
      return v;
    }

    async function pollAgent() {
      if (!threadId || document.hidden) return;
      try {
        var draft = draftNow();
        var beat = '&p=' + encodeURIComponent(location.pathname);
        if (draft !== null && draft !== lastDraftSent) {
          beat += '&t=' + encodeURIComponent(draft);
          lastDraftSent = draft;
        }
        var r = await fetch(POLL_ENDPOINT + '?thread=' + encodeURIComponent(threadId) +
                            '&after=' + agentLastId + beat, { method: 'GET' });
        var d = await r.json();
        if (d.messages && d.messages.length) {
          var acts = [];
          d.messages.forEach(function (m) {
            /* Recorded before the action runs: a navigate ends this page, and
               anything not written down by then is repeated on the next load. */
            markAgentSeen(m.id);
            /* A change of state, not something a person said — rendered the way
               Messages renders "You unsent a message": small, centred, no
               bubble, no avatar, no typing pause before it. */
            if (m.action && m.action.type === 'system') {
              if (m.text) systemNote(m.text);
              return;
            }
            /* The agent closed the conversation. Their closing line is shown
               like any other, then the session is let go: whatever they say
               next starts a new conversation rather than reopening one both
               people consider finished. The panel is left open — closing it
               under someone mid-read would feel like being hung up on. */
            if (m.action && m.action.type === 'end') {
              if (m.text) bubble(m.text, 'bot');
              markAgentSeen(m.id);
              endedByAgent();
              return;
            }
            if (m.text) bubble(m.text, 'bot');
            if (m.action) acts.push(m.action);
          });
          /* The agent used Forward. Routed through applyActions so it takes the
             same path as the assistant's own navigate action — the visitor
             reads the line before the page moves under them. */
          if (acts.length) {
            await applyActions(acts);
            if (pendingNavigation) {
              var target = pendingNavigation;
              pendingNavigation = null;
              /* Belt and braces on top of the persisted id: if the visitor is
                 already on that page, navigating achieves nothing and risks
                 another round trip. */
              if (target.split('?')[0] !== location.pathname) {
                writeStore(OPEN_KEY, '1');
                location.assign(target);
              }
            }
          }
        }
        /* Match the cadence to who is answering, but keep listening either way
           — the next takeover has to be noticed too. An open panel is quicker
           still: this poll is what carries the draft to the console. */
        startAgentPolling(isOpen ? 3000 : (d.agentMode ? 4000 : 12000));
      } catch (e) { /* a dropped poll is not worth telling the customer about */ }
    }

    var NAME_KEY = 'dcChatName';
    /* Restored further down, NOT here. readStore() is hoisted so calling it at this
       point does not throw - but `store` is still undefined, so it silently returns
       null and the name was ALWAYS empty. The visible symptom: click a link the
       assistant sent, the page reloads, the conversation comes back correctly, and
       then the "What should we call you?" gate appears again to someone who already
       gave their name. It also meant the name never reached the server after any
       navigation, and "good to see you back" could never fire. */
    var customerName = '';

    /* Ask for a first name before the conversation starts.

       Without it the agent console lists six anonymous conversations and
       whoever is covering has no way to tell them apart, or to greet someone by
       name when they step in. Asked once and remembered, so a returning visitor
       is not asked again.

       Kept deliberately light: one line, skippable by just answering the
       question they came to ask. The first thing a person types is treated as a
       name only when it looks like one — someone who opens with "how much is
       shipping" gets an answer, not a request for ID. */
    function looksLikeName(t) {
      var s = String(t || '').trim();
      if (!s || s.length > 40) return false;
      if (/[?!@0-9$]/.test(s)) return false;
      var words = s.split(/\s+/);
      if (words.length > 3) return false;
      return /^[A-Za-z][A-Za-z'’\-\.]*$/.test(words[0]);
    }
    function rememberName(t) {
      var s = String(t || '').trim().replace(/^(hi|hello|hey)[,\s]+/i, '')
              .replace(/^(i'?m|it'?s|this is|my name is)\s+/i, '').replace(/[.,]$/, '');
      if (!looksLikeName(s)) return false;
      customerName = s.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      try { writeStore(NAME_KEY, customerName); } catch (e) {}
      return true;
    }

    var THREAD_KEY = 'dcChatThread';
    var LOG_KEY = 'dcChatLog';
    var START_KEY = 'dcChatStarted';
    var OPEN_KEY = 'dcChatOpen';
    var VIEW_KEY = 'dcChatViews';
    var PENDING_KEY = 'dcChatPending';   // messages queued but not yet said

    /* ---------- helpers ---------- */

    /* Human pacing, 25% quicker than the original figures (Ben, 2026-08-09).
       The delays are deliberate — a reply that lands instantly reads as a
       machine — but the first version made people wait through a paragraph
       being "typed". Typing 90-128ms/char, read pause 23ms/char, 0.4-1.1s
       between messages, 3.8-11.3s to connect. */
    function rnd(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    function typeTime(t) { return Math.min(Math.max(t.length * rnd(90, 128), 1125), 18750); }
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    /* Render text into a node. Strips any raw {{...}} defensively, turns
       [[label|/path]] into anchors (relative paths only), everything else is
       plain text nodes. */
    /* A state change in the conversation, styled like iMessage's own notices. */
    /* Closed from the console. Distinct from endChat(), which is the visitor
       pressing End: that one wipes the panel and says goodbye. Here they may
       still be reading, so the transcript stays on screen and only the session
       is released. */
    function endedByAgent() {
      stopAgentPolling();
      clearSession();
      greeted = true;            // no reconnect theatre if they type again
      userSpoke = false;
      queue.length = 0;
      typing(false);
      systemNote('This conversation has been closed.');
      if (endBtn) endBtn.classList.add('dc-chat__hide');
    }

    /* A casket, shown. Built with createElement like every other bubble — the
       server sends a URL and a title, and nothing here trusts either enough to
       hand it to innerHTML. */
    function photoBubble(act, skipPersist) {
      var row = el('div', 'dc-chat__row dc-chat__row--them');
      var card = el('a', 'dc-chat__photo');
      card.href = act.path || '#';
      var img = document.createElement('img');
      img.src = act.url;
      img.alt = act.title || 'Casket';
      img.loading = 'lazy';
      img.className = 'dc-chat__photo-img';
      card.appendChild(img);
      if (act.note) {
        /* Said plainly, on the picture: these were taken by people who bought
           the casket, not by us, and a family should know which they are
           looking at. */
        card.appendChild(el('span', 'dc-chat__photo-note', act.note));
      }
      if (act.title) {
        var cap = el('span', 'dc-chat__photo-cap');
        cap.appendChild(el('b', '', act.title));
        if (act.price) {
          cap.appendChild(el('span', 'dc-chat__photo-price',
            '$' + Number(act.price / 100).toLocaleString('en-US', { minimumFractionDigits: 0 })));
        }
        card.appendChild(cap);
      }
      row.appendChild(card);
      log.appendChild(row);
      scrollLog();
      lastRole = null;
      if (!skipPersist) {
        /* Persisted like any other message. They were not, so clicking a link
           the assistant had just sent took the visitor to the product page and
           every photograph vanished from the conversation. */
        transcript.push({ r: 'photo', act: act });
        persist();
      }
    }

    function systemNote(text) {
      var n = el('div', 'dc-chat__system', String(text));
      log.appendChild(n);
      scrollLog();
    }

    function renderInto(node, text) {
      var cleaned = String(text).replace(/\{\{[^}]*\}\}/g, '');
      var pieces = cleaned.split(/(\[\[[^\]]+\]\])/g);
      for (var i = 0; i < pieces.length; i++) {
        var piece = pieces[i];
        if (!piece) continue;
        var m = piece.match(/^\[\[([^|\]]+)\|([^\]]+)\]\]$/);
        if (m && /^\/[^\s]*$/.test(m[2].trim())) {
          var a = el('a', 'dc-chat__link', m[1].trim());
          a.href = m[2].trim();
          node.appendChild(a);
        } else {
          node.appendChild(document.createTextNode(piece.replace(/^\[\[|\]\]$/g, '')));
        }
      }
    }

    /* ---------- markup ---------- */

    var launch = el('button', 'dc-chat__launch');
    launch.type = 'button';
    launch.setAttribute('aria-label', 'Open chat');
    var launchIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    launchIcon.setAttribute('viewBox', '0 0 24 24');
    launchIcon.setAttribute('aria-hidden', 'true');
    var launchPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    launchPath.setAttribute('d', 'M21 12c0 4.556-4.03 8.25-9 8.25a9.76 9.76 0 01-2.555-.337A5.97 5.97 0 015.41 20.97a4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z');
    launchPath.setAttribute('stroke-linecap', 'round');
    launchPath.setAttribute('stroke-linejoin', 'round');
    launchIcon.appendChild(launchPath);
    launch.appendChild(launchIcon);
    var badge = el('span', 'dc-chat__badge dc-chat__hide');
    launch.appendChild(badge);

    var panel = el('div', 'dc-chat__panel dc-chat__hide');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', TITLE + ' chat');

    var head = el('div', 'dc-chat__head');
    var headText = el('div', 'dc-chat__head-text');
    var titleEl = el('div', 'dc-chat__title', TITLE);
    var statusEl = el('div', 'dc-chat__status dc-chat__status--off', 'Connecting…');
    headText.appendChild(titleEl);
    headText.appendChild(statusEl);
    var endBtn = el('button', 'dc-chat__end dc-chat__hide', 'End chat');
    endBtn.type = 'button';
    endBtn.setAttribute('aria-label', 'End this chat and start over');
    var closeBtn = el('button', 'dc-chat__close', '×');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Minimise chat');
    head.appendChild(headText);
    head.appendChild(endBtn);
    head.appendChild(closeBtn);

    var log = el('div', 'dc-chat__log');
    log.setAttribute('aria-live', 'polite');

    var foot = el('div', 'dc-chat__foot');
    var input = el('input', 'dc-chat__input');
    input.type = 'text';
    input.placeholder = 'Type your message…';
    input.autocomplete = 'off';
    var sendBtn = el('button', 'dc-chat__send');
    sendBtn.type = 'button';
    sendBtn.disabled = true;
    sendBtn.setAttribute('aria-label', 'Send message');
    var sendIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    sendIcon.setAttribute('viewBox', '0 0 24 24');
    sendIcon.setAttribute('aria-hidden', 'true');
    var sendPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    sendPath.setAttribute('d', 'M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18');
    sendPath.setAttribute('stroke-linecap', 'round');
    sendPath.setAttribute('stroke-linejoin', 'round');
    sendIcon.appendChild(sendPath);
    sendBtn.appendChild(sendIcon);
    foot.appendChild(input);
    foot.appendChild(sendBtn);

    var phoneNote = el('div', 'dc-chat__phone', 'Prefer to talk? Call us at ' + PHONE + '.');

    /* Pre-chat gate.

       Asking conversationally did not work: the question can be ignored, and
       the console filled with "Guest". This is a field that has to be filled in
       before the conversation exists at all — no thread is created and the
       assistant is never called until it is submitted.

       Deliberately one field. Every extra box costs conversations, and a first
       name is all the console needs to stop being a list of strangers. */
    var gate = el('div', 'dc-chat__gate');
    var gateTitle = el('div', 'dc-chat__gate-title', 'Before we start');
    var gateBody = el('label', 'dc-chat__gate-label', 'What should we call you?');
    var gateInput = el('input', 'dc-chat__gate-input');
    gateInput.type = 'text';
    gateInput.placeholder = 'First name';
    gateInput.autocomplete = 'given-name';
    gateInput.setAttribute('aria-label', 'Your first name');
    gateBody.appendChild(gateInput);
    var gateBtn = el('button', 'dc-chat__gate-btn', 'Start chat');
    gateBtn.type = 'button';
    var gateErr = el('div', 'dc-chat__gate-err');
    gate.appendChild(gateTitle);
    gate.appendChild(gateBody);
    gate.appendChild(gateErr);
    gate.appendChild(gateBtn);

    panel.appendChild(head);
    panel.appendChild(gate);
    panel.appendChild(log);
    panel.appendChild(foot);
    panel.appendChild(phoneNote);
    root.appendChild(launch);
    root.appendChild(panel);

    /* ---------- state ---------- */

    var threadId = null, isOpen = false, unread = 0, greeted = false,
        connecting = false, userSpoke = false, draining = false,
        pendingFirstMessage = '',
        queue = [], sending = false, lastRole = null, typEl = null,
        transcript = [];

    var wasOpen = false;

    /* A conversation outlives reloads and navigation. It ends only when the
       customer presses "End chat" or when it is older than 24h, so someone
       arranging a funeral across several visits keeps their context. */
    var MAX_AGE_MS = 24 * 60 * 60 * 1000;
    var store = (function () {
      try {
        localStorage.setItem('__dcprobe', '1');
        localStorage.removeItem('__dcprobe');
        return localStorage;
      } catch (e) {
        try { sessionStorage.setItem('__dcprobe', '1'); sessionStorage.removeItem('__dcprobe'); return sessionStorage; }
        catch (e2) { return null; }
      }
    })();

    function readStore(k) { try { return store ? store.getItem(k) : null; } catch (e) { return null; } }

    /* Now that `store` exists, the name can actually be restored. */
    customerName = readStore(NAME_KEY) || '';
    function writeStore(k, v) { try { if (store) store.setItem(k, v); } catch (e) { /* quota / private mode */ } }
    function dropStore(k) { try { if (store) store.removeItem(k); } catch (e) { /* noop */ } }

    function clearSession() {
      /* AGENT_SEEN_KEY goes with them: the high-water mark belongs to the old
         conversation, and a new one starting behind it would never be shown. */
      [THREAD_KEY, LOG_KEY, START_KEY, OPEN_KEY, VIEW_KEY, AGENT_SEEN_KEY,
       PENDING_KEY].forEach(dropStore);
      threadId = null;
      transcript = [];
      agentLastId = 0;
    }

    try {
      var started = parseInt(readStore(START_KEY) || '0', 10);
      if (started && (Date.now() - started) > MAX_AGE_MS) {
        clearSession();
      } else {
        threadId = readStore(THREAD_KEY) || null;
        transcript = JSON.parse(readStore(LOG_KEY) || '[]');
        wasOpen = readStore(OPEN_KEY) === '1';
      }
      if (!Array.isArray(transcript)) transcript = [];
    } catch (e) { transcript = []; }

    /* A restored conversation starts listening straight away, so an agent can
       take over and speak to someone who is sitting on the page saying nothing.
       Resumed on tab focus too — pollAgent skips while the tab is hidden. */
    if (threadId) startAgentPolling(12000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && threadId) pollAgent();
    });

    function syncEndBtn() {
      if (threadId || transcript.length) endBtn.classList.remove('dc-chat__hide');
      else endBtn.classList.add('dc-chat__hide');
    }

    function persist() {
      syncEndBtn();
      writeStore(LOG_KEY, JSON.stringify(transcript.slice(-100)));
      if (threadId) writeStore(THREAD_KEY, threadId);
      if (!readStore(START_KEY)) writeStore(START_KEY, String(Date.now()));
    }

    /* A short trail of what the visitor has been reading — products, collections,
       guides, policy pages. It lets the assistant continue from what they were
       already looking at instead of asking them to describe it again. Kept in the
       browser and sent only to our own endpoint. */
    function pageKind(path) {
      if (path.indexOf('/products/') === 0) return 'product';
      if (path.indexOf('/collections/') === 0) return 'collection';
      if (path.indexOf('/blogs/') === 0) return 'article';
      if (path.indexOf('/pages/') === 0) return 'page';
      if (path.indexOf('/policies/') === 0) return 'policy';
      if (path.indexOf('/search') === 0) return 'search';
      if (path === '/cart') return 'cart';
      if (path === '/') return 'home';
      return 'page';
    }

    function recordView() {
      var path = location.pathname;
      if (/^\/(account|checkout|orders)/.test(path)) return;   // don't log private pages
      var kind = pageKind(path);
      var label = (document.title || '').replace(/\s*[|\u2013\u2014-]\s*Discount Caskets.*$/i, '').trim();
      if (kind === 'search') {
        var q = new URLSearchParams(location.search).get('q');
        if (q) label = 'searched for "' + q.slice(0, 60) + '"';
      }
      var views = [];
      try { views = JSON.parse(readStore(VIEW_KEY) || '[]'); } catch (e) { views = []; }
      if (!Array.isArray(views)) views = [];
      if (views.length && views[views.length - 1].p === path) return;   // same page again
      views.push({ p: path, t: label.slice(0, 90), k: kind, ts: Date.now() });
      writeStore(VIEW_KEY, JSON.stringify(views.slice(-15)));
    }

    /* ---------- who this visitor is, for the agent console ----------

       An agent taking a conversation over is answering blind unless they know
       where the person is, how they got here and how long they have been
       reading. Only the browser knows the arrival: by the time they type, the
       referrer and the campaign parameters are several navigations behind them.
       So the arrival is captured on the FIRST page of the visit and kept.

       Nothing here is shown to the customer or given to the assistant. */
    var ARRIVE_KEY = 'dcChatArrival';    // this visit
    var SEEN_KEY = 'dcChatSeen';         // across visits

    function arrival() {
      var a = null;
      try { a = JSON.parse(readStore(ARRIVE_KEY) || 'null'); } catch (e) { a = null; }
      /* A visit is the same visit until 30 minutes of silence — the usual
         analytics convention, and it keeps a referrer alive across the reload
         that adding to cart causes. */
      if (a && a.ts && (Date.now() - a.ts) < 30 * 60 * 1000) {
        a.ts = Date.now();
        writeStore(ARRIVE_KEY, JSON.stringify(a));
        return a;
      }

      var q = new URLSearchParams(location.search);
      var utm = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (k) {
        var v = q.get(k); if (v) utm[k.replace('utm_', '')] = v.slice(0, 120);
      });
      ['gclid', 'fbclid', 'msclkid'].forEach(function (k) {
        var v = q.get(k); if (v) utm[k] = v.slice(0, 120);
      });

      var seen = {};
      try { seen = JSON.parse(readStore(SEEN_KEY) || '{}') || {}; } catch (e) { seen = {}; }
      seen.n = (parseInt(seen.n, 10) || 0) + 1;
      seen.first = parseInt(seen.first, 10) || Math.round(Date.now() / 1000);
      writeStore(SEEN_KEY, JSON.stringify(seen));

      a = {
        ts: Date.now(),
        started: Math.round(Date.now() / 1000),
        landing: location.pathname,
        landingTitle: (document.title || '').replace(/\s*[|–—-]\s*Discount Caskets.*$/i, '').trim().slice(0, 90),
        /* document.referrer is same-origin on every page after the first, which
           would overwrite "came from Google" with "came from our own homepage" */
        referrer: (document.referrer || '').indexOf(location.host) === -1 ? (document.referrer || '') : '',
        utm: utm,
        visits: seen.n,
        firstSeen: seen.first
      };
      writeStore(ARRIVE_KEY, JSON.stringify(a));
      return a;
    }

    /* ---------- heartbeat ----------

       Every visitor, on every page, whether or not they ever open the chat —
       which is how the console shows a traffic view at all. The id is the
       browser's own and ties one person's page views together; it is not a
       login and identifies nobody by name.

       Twenty seconds while the tab is in front, nothing at all while it is
       hidden: a forgotten background tab must not look like somebody standing
       in the shop. */
    var VISIT_ENDPOINT = (root.dataset.endpoint || 'https://chat.discount-caskets.com/chat.php')
      .replace(/chat\.php$/, 'visit.php');
    var VID_KEY = 'dcVisitorId';
    var beatTimer = null;

    function searchTerm() {
      if (!/^\/search/.test(location.pathname)) return '';
      try {
        return (new URLSearchParams(location.search).get('q') || '').trim().slice(0, 80);
      } catch (e) { return ''; }
    }

    function visitorId() {
      var v = readStore(VID_KEY);
      if (v) return v;
      try { v = crypto.randomUUID(); }
      catch (e) { v = 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
      writeStore(VID_KEY, v);
      return v;
    }

    function heartbeat() {
      if (document.hidden) return;
      try {
        fetch(VISIT_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({
            vid: visitorId(),
            page: location.pathname,
            title: (document.title || '').replace(/\s*[|\u2013\u2014-]\s*Discount Caskets.*$/i, '').trim().slice(0, 90),
            threadId: threadId || '',
            /* The only search term anybody can actually see. Google, Bing and
               DuckDuckGo have stripped the query out of the referrer for years
               — this is what they typed into OUR box. */
            search: searchTerm(),
            visitor: visitorInfo()
          })
        }).catch(function () { /* a missed beat is a missing row, nothing more */ });
      } catch (e) { /* noop */ }
    }

    function startHeartbeat() {
      if (beatTimer) return;
      heartbeat();
      beatTimer = setInterval(heartbeat, 20000);
    }

    /* Say goodbye on the way out, so the console shows who is on the site
       rather than who was there a minute ago. sendBeacon because a normal
       fetch is cancelled when the page unloads.

       The server treats this as provisional: the next heartbeat clears it, so
       moving from one page to the next does not read as leaving. */
    function farewell() {
      if (!threadId && !readStore(VID_KEY)) return;
      try {
        var payload = JSON.stringify({ vid: visitorId(), gone: true });
        if (navigator.sendBeacon) {
          navigator.sendBeacon(VISIT_ENDPOINT, new Blob([payload], { type: 'application/json' }));
        }
      } catch (e) { /* nothing to be done at unload time */ }
    }

    function visitorInfo() {
      var a = arrival();
      return {
        landing: a.landing, landingTitle: a.landingTitle, referrer: a.referrer,
        utm: a.utm || {}, visits: a.visits, firstSeen: a.firstSeen, started: a.started,
        screen: (screen.width || 0) + 'x' + (screen.height || 0),
        viewport: (window.innerWidth || 0) + 'x' + (window.innerHeight || 0),
        tz: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; } })(),
        lang: navigator.language || ''
      };
    }

    /* What the visitor is looking at RIGHT NOW. Without this, "I like this one"
       has no referent and the assistant guesses from the cart. On a product page we
       pull the real product from Shopify's own /products/<handle>.js so the title,
       price and variantId are authoritative rather than model-generated. */
    var pageProduct = null, pageProductPath = null;

    function loadPageProduct() {
      var path = location.pathname;
      if (path.indexOf('/products/') !== 0) { pageProduct = null; pageProductPath = path; return Promise.resolve(null); }
      if (pageProductPath === path) return Promise.resolve(pageProduct);
      return fetch(path.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (pr) {
          pageProductPath = path;
          if (!pr) { pageProduct = null; return null; }
          var v = (pr.variants || []).filter(function (x) { return x.available; })[0] || (pr.variants || [])[0] || null;
          pageProduct = {
            handle: pr.handle, title: pr.title,
            priceCents: v ? v.price : pr.price,
            variantId: v ? String(v.id) : null,
            available: v ? !!v.available : false,
            variantTitle: v && v.title !== 'Default Title' ? v.title : ''
          };
          return pageProduct;
        })
        .catch(function () { pageProduct = null; return null; });
    }

    function currentPage() {
      var path = location.pathname;
      var label = (document.title || '').replace(/\s*[|\u2013\u2014-]\s*Discount Caskets.*$/i, '').trim();
      var ctx = { path: path, kind: pageKind(path), title: label.slice(0, 120) };
      if (pageProduct && pageProductPath === path) ctx.product = pageProduct;
      return ctx;
    }

    function recentViews() {
      var views = [];
      try { views = JSON.parse(readStore(VIEW_KEY) || '[]'); } catch (e) { return []; }
      if (!Array.isArray(views)) return [];
      var cutoff = Date.now() - MAX_AGE_MS;
      return views.filter(function (v) { return v && v.ts > cutoff; }).slice(-12);
    }

    function paintBadge() {
      if (unread > 0) {
        badge.textContent = String(unread);
        badge.classList.remove('dc-chat__hide');
        launch.setAttribute('aria-label', unread + ' new message' + (unread > 1 ? 's' : '') + ' — open chat');
      } else {
        badge.classList.add('dc-chat__hide');
        launch.setAttribute('aria-label', 'Open chat');
      }
    }

    function scrollLog() { log.scrollTop = log.scrollHeight; }

    function bubble(text, role, skipPersist) {
      var row = el('div', 'dc-chat__row dc-chat__row--' + role + (lastRole === role ? ' dc-chat__row--same' : ''));
      var b = el('div', 'dc-chat__bubble');
      renderInto(b, text);
      row.appendChild(b);
      log.appendChild(row);
      lastRole = role;
      scrollLog();
      if (!skipPersist) {
        transcript.push({ r: role, t: text });
        persist();
      }
      if (!isOpen && role === 'them') { unread++; paintBadge(); }
    }

    function typing(on) {
      if (on && !typEl) {
        typEl = el('div', 'dc-chat__typing');
        typEl.appendChild(el('i'));
        typEl.appendChild(el('i'));
        typEl.appendChild(el('i'));
        log.appendChild(typEl);
        scrollLog();
      } else if (!on && typEl) {
        typEl.remove();
        typEl = null;
      }
    }

    function online(on) {
      connecting = !on;
      statusEl.textContent = on ? 'Online' : 'Connecting…';
      statusEl.classList.toggle('dc-chat__status--off', !on);
    }

    /* Restore a previous session's transcript */
    if (transcript.length) {
      greeted = true;
      transcript.forEach(function (m) {
        if (m.r === 'photo' && m.act) photoBubble(m.act, true);
        else bubble(m.t, m.r, true);
      });
      unread = 0;
      online(true);
      endBtn.classList.remove('dc-chat__hide');
    }

    /* ---------- greeting ---------- */

    /* Show the gate, or take it down once we have a name. */
    function setGate(on, heading) {
      if (on) gateTitle.textContent = heading || 'Before we start';
      gate.classList.toggle('dc-chat__hide', !on);
      log.classList.toggle('dc-chat__hide', on);
      foot.classList.toggle('dc-chat__hide', on);
      if (on) setTimeout(function () { gateInput.focus(); }, 60);
    }
    function submitGate() {
      var v = gateInput.value.trim();
      if (!rememberName(v)) {
        gateErr.textContent = v ? 'Please use just your first name.' : 'Please enter your first name.';
        gateInput.focus();
        return;
      }
      gateErr.textContent = '';
      setGate(false);
      /* They were part-way through asking something when the gate appeared.
         Put it back and send it — nobody should have to type a question twice
         because we wanted their name. */
      if (pendingFirstMessage) {
        input.value = pendingFirstMessage;
        pendingFirstMessage = '';
        sendBtn.disabled = false;
        send();
        setTimeout(function () { input.focus(); }, 80);
        return;
      }
      greeted = false;
      greet();
      setTimeout(function () { input.focus(); }, 80);
    }
    gateBtn.addEventListener('click', submitGate);
    gateInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); submitGate(); }
    });

    async function greet() {
      if (greeted) return;
      greeted = true;
      online(false);
      await wait(rnd(3750, 11250));
      online(true);
      if (userSpoke) return;
      /* Warmer than it was (Ben, 2026-09-25) but it still identifies itself in the
         first line — that was a deliberate call and it stays. "Hi, you're chatting
         with the Discount Caskets assistant." read like a recorded message; this
         says the same thing the way a person would. */
      var lines = customerName
        ? ["Hey there, " + customerName + " — good to see you back.",
           'What can I answer for you?']
        : ["Hey there — you're chatting with the Discount Caskets assistant.",
           'What can I answer for you?'];
      for (var i = 0; i < lines.length; i++) {
        if (userSpoke) return;
        typing(true);
        await wait(typeTime(lines[i]));
        typing(false);
        if (userSpoke) return;
        bubble(lines[i], 'them');
        if (i === 0) await wait(rnd(750, 2250));
      }
    }

    /* ---------- cart integration ---------- */

    function fetchCart() {
      return fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }

    function cartForRequest() {
      return fetchCart().then(function (cart) {
        if (!cart || !cart.items) return [];
        return cart.items.map(function (it) {
          return {
            variantId: String(it.variant_id),
            name: it.product_title || it.title || '',
            price: it.price,
            qty: it.quantity
          };
        });
      });
    }

    function refreshCartUI() {
      return fetchCart().then(function (cart) {
        if (!cart) return;
        /* header-custom.js listens for this: updates the [data-cart-count]
           badge from detail.resource.item_count and re-syncs the drawer for
           any source other than its own. */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { didError: false, source: 'live-chat' }, resource: cart }
        }));
        /* Direct fallback in case no listener is bound on this template. */
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = String(cart.item_count);
          n.classList.toggle('visually-hidden', cart.item_count === 0);
        });
      });
    }

    var pendingNavigation = null;

    async function applyActions(actions) {
      if (!actions || !actions.length) return;
      var mutated = false, failed = [];
      for (var i = 0; i < actions.length; i++) {
        var act = actions[i];
        try {
          if (act.type === 'photo' && act.url) {
            // Queued, not drawn: see drain(). Reaching here means an AGENT sent
            // it out of band, where there is no queue to wait for.
            photoBubble(act);
          } else if (act.type === 'navigate' && act.url) {
            // Held until the message has finished typing out, so the visitor reads the
            // sentence before the page moves under them. Last one wins.
            pendingNavigation = act.url;
          } else if (act.type === 'add' && act.variantId) {
            var res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(act.variantId), quantity: 1 }] })
            });
            if (res.ok) mutated = true;
            else failed.push(act.name || 'that item');
          } else if (act.type === 'remove' && act.variantId) {
            var cart = await fetchCart();
            if (!cart || !cart.items) continue;
            var line = cart.items.find(function (it) { return String(it.variant_id) === String(act.variantId); });
            if (!line) continue;
            var res2 = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
            if (res2.ok) mutated = true;
          }
        } catch (e) { failed.push(act.name || 'that item'); }
      }
      if (mutated) await refreshCartUI();
      // Never let "I've added it" stand when the cart did not actually change.
      if (failed.length) {
        bubble("I'm sorry — I couldn't add " + failed.join(' or ') + " to your cart from here. "
               + 'You can add it from the product page, or call us at ' + PHONE + '.', 'them');
      }
      return mutated;
    }

    /* ---------- message queue ---------- */

    /* What has not been said yet, kept where a page change cannot lose it.

       The assistant answers in several short messages with a human pause
       between them. Click a link it has just sent while it is still talking and
       the page navigates, this script is destroyed, and every queued message
       goes with it — the visitor arrives on the product page and the answer
       simply stops. Ben hit exactly that. So the queue is written down as it
       shrinks, and picked up again on the next page. */
    function savePending() {
      try {
        if (queue.length) writeStore(PENDING_KEY, JSON.stringify(queue));
        else dropStore(PENDING_KEY);
      } catch (e) { /* private mode */ }
    }

    async function drain() {
      if (draining) return;
      draining = true;
      while (queue.length) {
        var part = queue.shift();
        savePending();
        /* A photograph is a message like any other and waits its turn. They
           used to be drawn the instant the response arrived, while the
           sentences were still typing out, so the pictures appeared above the
           line introducing them. */
        if (part && typeof part === 'object' && part.photo) {
          typing(true);
          await wait(rnd(500, 900));
          typing(false);
          photoBubble(part.photo);
          if (queue.length) await wait(rnd(250, 500));
          continue;
        }
        typing(true);
        await wait(typeTime(part));
        typing(false);
        bubble(part, 'them');
        if (queue.length) await wait(rnd(375, 1125));
      }
      draining = false;
      savePending();
    }

    /* Finish what was interrupted. Quicker than the first time round: the
       visitor has already waited through the pause once, and a page they just
       loaded should not sit there typing at them for ten seconds. */
    async function resumePending() {
      var rest = [];
      try { rest = JSON.parse(readStore(PENDING_KEY) || '[]'); } catch (e) { rest = []; }
      if (!Array.isArray(rest) || !rest.length) return;
      dropStore(PENDING_KEY);
      await wait(600);
      for (var i = 0; i < rest.length; i++) {
        var item = rest[i];
        if (item && typeof item === 'object' && item.photo) {
          photoBubble(item.photo);
          if (i < rest.length - 1) await wait(300);
          continue;
        }
        typing(true);
        await wait(Math.min(typeTime(item) * 0.5, 2500));
        typing(false);
        bubble(item, 'them');
        if (i < rest.length - 1) await wait(400);
      }
    }

    async function send() {
      var text = input.value.trim();
      if (!text || sending) return;
      /* The console needs a name or it fills up with strangers, but asking
         before they have said anything costs conversations and reads as a
         toll gate. So it is asked here, once, at the first message — the
         moment there is something to attribute. The thread is still never
         created without one. userSpoke stops any greeting in flight from
         typing itself out behind the gate. */
      if (!customerName) {
        pendingFirstMessage = text;
        userSpoke = true;
        input.value = '';
        sendBtn.disabled = true;
        setGate(true, 'One quick thing');
        return;
      }
      input.value = '';
      sendBtn.disabled = true;
      userSpoke = true;
      sending = true;
      queue.length = 0; /* a new user message flushes the pending reply queue */
      typing(false);
      bubble(text, 'me');

      while (connecting) { await wait(200); }
      try {
        await loadPageProduct();
        var cart = await cartForRequest();
        var res = await fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: text, threadId: threadId, page: location.pathname,
            cart: cart, viewed: recentViews(), pageCtx: currentPage(),
            visitor: visitorInfo(),
            customerName: customerName || ''
          })
        });
        var data = await res.json();
        if (data.threadId) {
          threadId = data.threadId;
          persist();
        }
        await wait(Math.min(Math.max(text.length * 23, 1125), 3000));
        /* Pictures are held back from applyActions and queued behind the
           sentences instead — a photograph that lands before the line
           introducing it reads as though the assistant answered twice. Cart
           changes and navigation still go through immediately; only the
           rendering waits. */
        var allActs = data.actions || [];
        var photoActs = allActs.filter(function (a) { return a && a.type === 'photo' && a.url; });
        var otherActs = allActs.filter(function (a) { return !(a && a.type === 'photo'); });
        var cartWork = otherActs.length
          ? applyActions(otherActs)
          : Promise.resolve(false);
        var parts = (data.parts && data.parts.length)
          ? data.parts
          : (data.agentMode ? []
             : [data.error || "I'm sorry, could you try that again?"]);
        /* A person has taken the conversation: the assistant stays silent and
           their reply arrives out-of-band, so start listening for it. */
        startAgentPolling(isOpen ? 3000 : (data.agentMode ? 4000 : 12000));
        queue.push.apply(queue, parts);
        photoActs.forEach(function (a) { queue.push({ photo: a }); });
        sending = false;
        await drain();
        /* The cart changed, so line items, totals and the header count are all stale.
           Reload the page the visitor is on to resync them. This is only safe because
           the conversation persists and the panel reopens itself — see openPanel. */
        var changed = await cartWork;
        if (pendingNavigation) {
          /* Going somewhere new also resyncs the cart, so it supersedes the reload. */
          var target = pendingNavigation;
          pendingNavigation = null;
          persist();
          writeStore(OPEN_KEY, isOpen ? '1' : '0');
          await wait(1400);
          location.assign(target);
        } else if (changed) {
          persist();
          writeStore(OPEN_KEY, isOpen ? '1' : '0');
          await wait(1400);
          location.reload();
        }
      } catch (e) {
        sending = false;
        typing(false);
        bubble("I'm sorry — the connection dropped. Please try again, or call us at " + PHONE + '.', 'them');
      }
    }

    /* ---------- the proactive nudge ----------

       A small card that comes up beside the launcher when someone has been
       reading one casket for a while, or has compared several, or is on their
       way out. It is not the panel opening itself and it is not a modal: these
       are people arranging a funeral, frequently within a day or two of a
       death, and a window seizing the screen while they read is the wrong
       thing to do to them. This can be read at a glance and waved off in one
       tap, and it takes itself away if it is ignored.

       Rules are listed strongest-signal-first and the first match wins. At
       most one in 24 hours; waving it off buys a week of quiet, and so does
       having already had a conversation. Nothing is sent to the server — no
       thread, no session, no message exists until they click it. */

    var NUDGE_KEY = 'dcChatNudge';
    var NUDGE_QUIET_MS = 24 * 60 * 60 * 1000;         // after it has been shown
    var NUDGE_LONG_MS = 7 * 24 * 60 * 60 * 1000;      // after it has been refused
    var NUDGE_IDLE_MS = 60 * 1000;                    // no scroll, no keys: not reading
    var NUDGE_LINGER_MS = 30 * 1000;                  // unanswered, it withdraws

    var nudgeActive = 0, nudgeLastAct = Date.now(), nudgeDepth = 0,
        nudgeExit = false, nudgeDone = false, nudgeCart,
        nudgeRule = '', nudgeLine = '', nudgeBeatTimer = null, nudgeGoTimer = null;

    var peek = el('div', 'dc-chat__peek dc-chat__hide');
    var peekBody = el('button', 'dc-chat__peek-body');
    peekBody.type = 'button';
    var peekText = el('span', 'dc-chat__peek-line');
    var peekCue = el('span', 'dc-chat__peek-cue', 'Ask a question');
    peekBody.appendChild(peekText);
    peekBody.appendChild(peekCue);
    var peekClose = el('button', 'dc-chat__peek-close', '×');
    peekClose.type = 'button';
    peekClose.setAttribute('aria-label', 'Dismiss');
    peek.appendChild(peekBody);
    peek.appendChild(peekClose);
    root.appendChild(peek);

    function nudgeMemory() {
      var m = null;
      try { m = JSON.parse(readStore(NUDGE_KEY) || 'null'); } catch (e) { m = null; }
      return (m && m.ts) ? m : null;
    }

    function rememberNudge(act) {
      writeStore(NUDGE_KEY, JSON.stringify({ ts: Date.now(), rule: nudgeRule, act: act }));
    }

    function nudgeAllowed() {
      if (nudgeDone || isOpen || document.hidden) return false;
      /* Already talking, or has talked: they do not need an invitation. */
      if (threadId || transcript.length || userSpoke) return false;
      if (/^\/(account|checkout|orders|challenge|tools)/.test(location.pathname)) return false;
      if (window.innerHeight < 480) return false;
      var m = nudgeMemory();
      /* "Shown and ignored" is a softer no than "closed" or "we already
         spoke", so it is the only one that comes back the next day. */
      if (m && (Date.now() - m.ts) < (m.act === 'shown' ? NUDGE_QUIET_MS : NUDGE_LONG_MS)) return false;
      return true;
    }

    function pickLine(a) { return a[Math.floor(Math.random() * a.length)]; }

    /* "Batesville Ivory Mist Casket" -> "Batesville Ivory Mist". Saying "the
       Ivory Mist Casket casket" is the giveaway of a machine writing. */
    function shortName(t) {
      return String(t || '').replace(/\s*casket(s)?\s*$/i, '').trim();
    }

    function nudgeRules() {
      var path = location.pathname;
      var kind = pageKind(path);
      var prod = (pageProduct && pageProductPath === path) ? pageProduct : null;
      var name = prod ? shortName(prod.title) : '';
      var it = name ? 'the ' + name : 'this casket';

      var seenProducts = {};
      recentViews().forEach(function (v) { if (v && v.k === 'product') seenProducts[v.p] = 1; });
      var compared = Object.keys(seenProducts).length;

      var visits = 0;
      try { visits = parseInt((JSON.parse(readStore(SEEN_KEY) || '{}') || {}).n, 10) || 0; } catch (e) { visits = 0; }

      var inCart = (nudgeCart && nudgeCart.item_count) || 0;
      var cartName = inCart && nudgeCart.items && nudgeCart.items[0]
        ? shortName(nudgeCart.items[0].product_title) : '';
      var q = searchTerm();

      return [
        /* On the way out. Desktop only — there is no such gesture on a phone,
           and scroll-up heuristics fire on people who are simply reading. */
        { id: 'exit', when: nudgeExit && nudgeActive >= 15000, lines: [
          'Before you go — if you did not find the right casket, tell me what you need and I will look for you.',
          'If you did not find what you were looking for, I can help. Just say what you need.'
        ] },

        /* Something is in the cart. The question they have not asked yet is
           almost always whether it can be there in time. */
        { id: 'cart', when: inCart > 0 && nudgeActive >= 25000, lines: [
          cartName
            ? 'You have the ' + cartName + ' in your cart. If you need it by a particular day, tell me the date and I will check that it can get there.'
            : 'You have a casket in your cart. If you need it by a particular day, tell me the date and I will check that it can get there.',
          cartName
            ? 'Before you order the ' + cartName + ' — happy to confirm the delivery timing, or the funeral home address it should go to.'
            : 'Before you order, happy to confirm the delivery timing, or the funeral home address it should go to.'
        ] },

        /* Several caskets in one visit: they are comparing, and comparing is
           the part people find hardest to do alone. */
        { id: 'compare', when: kind === 'product' && compared >= 3 && nudgeActive >= 20000, lines: [
          'You have looked at a few of these. Tell me what matters most — budget, material, the interior — and I will narrow it down.',
          'Comparing a few? If you tell me the budget you are working with, I can show you the closest options.'
        ] },

        /* Read the page to the bottom. They went looking for a detail. */
        { id: 'specs', when: kind === 'product' && nudgeDepth >= 0.65 && nudgeActive >= 20000, lines: [
          name
            ? 'You have read the whole page for the ' + name + '. If a detail is not there — measurements, weight, what is included — just ask.'
            : 'If a detail is not on this page — measurements, weight, what is included — just ask and I will find it.'
        ] },

        /* Ben's case: sitting with one casket for a while. */
        { id: 'product', when: kind === 'product' && nudgeActive >= 45000, lines: [
          'Take your time. If you have any questions about ' + it + ' — the size, the interior, how quickly it can arrive — I am here.',
          'If anything about ' + it + ' is not clear, I can help. Measurements, delivery, anything at all.'
        ] },

        /* Reading the policies is rarely idle curiosity. */
        { id: 'policy', when: kind === 'policy' && nudgeActive >= 20000, lines: [
          'If you are checking delivery timing, tell me the service date and the funeral home and I will tell you what is realistic.'
        ] },

        { id: 'search', when: kind === 'search' && nudgeActive >= 15000, lines: [
          q
            ? 'Not finding "' + q.slice(0, 40) + '"? Describe what you are after and I will look — we carry more than the search box turns up.'
            : 'If the search is not turning up what you need, describe it to me and I will find it.'
        ] },

        { id: 'collection', when: kind === 'collection' && nudgeActive >= 50000, lines: [
          'There is a lot to go through here. Tell me a budget or a material and I can point you at a few.'
        ] },

        { id: 'returning', when: visits >= 2 && nudgeActive >= 25000, lines: [
          'Welcome back. If you would like to pick up where you left off, I am here.'
        ] },

        { id: 'browsing', when: nudgeActive >= 60000, lines: [
          'If you are not sure where to start, tell me a little about what you need and I will help you find it.'
        ] }
      ];
    }

    function hideNudge() {
      clearTimeout(nudgeGoTimer);
      peek.classList.remove('dc-chat__peek--in');
      setTimeout(function () { peek.classList.add('dc-chat__hide'); }, 340);
    }

    function showNudge(rule, line) {
      nudgeDone = true;
      clearInterval(nudgeBeatTimer);
      nudgeRule = rule;
      nudgeLine = line;
      peekText.textContent = line;
      peek.classList.remove('dc-chat__hide');
      requestAnimationFrame(function () { peek.classList.add('dc-chat__peek--in'); });
      rememberNudge('shown');
      /* Left unanswered it withdraws rather than sitting on the page. It still
         counts as shown: coming back an hour later would be the nagging. */
      nudgeGoTimer = setTimeout(hideNudge, NUDGE_LINGER_MS);
    }

    peekBody.addEventListener('click', function () {
      hideNudge();
      rememberNudge('taken');
      openPanel(false);
      /* This line IS the greeting — greeting again on top of it would have the
         assistant introduce itself to someone it has just spoken to. */
      greeted = true;
      online(true);
      bubble(nudgeLine, 'them');
      if (window.innerWidth >= 750) input.focus();
    });

    peekClose.addEventListener('click', function (e) {
      e.stopPropagation();
      hideNudge();
      rememberNudge('dismissed');
    });

    function nudgeBeat() {
      if (nudgeDone) return;
      if (!document.hidden && (Date.now() - nudgeLastAct) < NUDGE_IDLE_MS) nudgeActive += 1000;
      /* The cart is read once, lazily, and only for a visitor who is still
         here after fifteen seconds — not on every page load for everyone. */
      if (nudgeActive >= 15000 && nudgeCart === undefined) {
        nudgeCart = null;
        fetchCart().then(function (c) { nudgeCart = c; });
      }
      if (!nudgeAllowed()) return;
      var match = nudgeRules().filter(function (r) { return r.when; })[0];
      if (match) showNudge(match.id, pickLine(match.lines));
    }

    function nudgeStir() {
      nudgeLastAct = Date.now();
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var d = h > 0 ? Math.min(1, y / h) : 1;
      if (d > nudgeDepth) nudgeDepth = d;
    }

    /* Without storage we cannot keep the once-a-day promise, and a nudge on
       every page load is exactly the nagging Ben asked us to avoid. So in
       private mode the feature simply does not exist. */
    if (store) {
      ['scroll', 'pointerdown', 'keydown', 'wheel', 'touchmove'].forEach(function (ev) {
        window.addEventListener(ev, nudgeStir, { passive: true });
      });
      nudgeStir();
      nudgeBeatTimer = setInterval(nudgeBeat, 1000);

      var canHover = true;
      try { canHover = window.matchMedia('(hover: hover)').matches; } catch (e) { canHover = true; }
      if (canHover && window.innerWidth >= 750) {
        document.addEventListener('mouseout', function (e) {
          /* Leaving through the top of the window: the tabs, the address bar,
             the close button. Sideways and downwards are not departures. */
          if (e.relatedTarget || e.clientY > 0) return;
          nudgeExit = true;
          nudgeBeat();
        });
      }
    }

    /* ---------- events ---------- */

    function openPanel(withGreeting) {
      isOpen = true;
      unread = 0;
      paintBadge();
      launch.classList.add('dc-chat__hide');
      panel.classList.remove('dc-chat__hide');
      writeStore(OPEN_KEY, '1');
      if (window.innerWidth >= 750) input.focus();
      scrollLog();
      /* The name is no longer asked for at the door (Ben, 2026-08-20). Someone
         who opens the chat gets the chat; the one question we need is asked at
         the moment they actually say something — see send(). */
      setGate(false);
      if (withGreeting) greet();
      /* Quicker while they are actually in the panel: this is the poll that
         carries the draft, and a typing preview arriving 12 seconds late is
         not a preview. */
      if (threadId) startAgentPolling(3000);
    }

    /* Minimising is not ending — the conversation is still there when reopened. */
    function closePanel() {
      isOpen = false;
      panel.classList.add('dc-chat__hide');
      launch.classList.remove('dc-chat__hide');
      panel.style.height = '';
      writeStore(OPEN_KEY, '0');
      /* Whatever was half-written belongs to a panel that is now shut. Clear it
         at the far end rather than leaving it on an agent's screen. */
      if (threadId) {
        lastDraftSent = '';
        try {
          fetch(POLL_ENDPOINT + '?thread=' + encodeURIComponent(threadId) +
                '&after=' + agentLastId + '&t=&p=' + encodeURIComponent(location.pathname),
                { method: 'GET', keepalive: true });
        } catch (e) { /* best effort */ }
      }
      startAgentPolling(12000);
    }

    function endChat() {
      /* Tell the console before the local session is let go — after
         clearSession there is no thread id left to send. */
      if (threadId) {
        try {
          var u = POLL_ENDPOINT + '?thread=' + encodeURIComponent(threadId) + '&ended=1';
          if (navigator.sendBeacon) navigator.sendBeacon(u);
          else fetch(u, { method: 'GET', keepalive: true });
        } catch (e) { /* best effort */ }
      }
      clearSession();
      /* They have had their conversation and closed it. Being invited into
         another one tomorrow is the nagging; a week is the right silence. */
      rememberNudge('ended');
      nudgeDone = true;
      queue.length = 0;
      greeted = false; userSpoke = false; connecting = false;
      pendingFirstMessage = '';
      draining = false; sending = false; lastRole = null; unread = 0;
      typing(false);
      log.textContent = '';
      endBtn.classList.add('dc-chat__hide');
      online(false);
      bubble('This chat has ended. If you need anything else, just open it again '
             + 'or call us at ' + PHONE + '.', 'them', true);
      paintBadge();
      setTimeout(closePanel, 2500);
    }

    launch.addEventListener('click', function () { openPanel(true); });
    closeBtn.addEventListener('click', closePanel);
    endBtn.addEventListener('click', endChat);

    /* Chat buttons elsewhere on the page — the product page's "Chat" action,
       the support bar, the Need Help banner. Each was already marked up as a
       trigger but nothing ever listened, so they were dead controls: the PDP
       one is a <button data-action="open-chat">, the other two are
       <a href="#" data-chat-trigger>. Both spellings are honoured here.

       Delegated from the document rather than bound per element, because these
       sections can be re-rendered by the theme editor and by section rendering
       after this script has run; a bound listener would be lost, a delegated
       one cannot be. */
    document.addEventListener('click', function (e) {
      /* The click usually lands on an <svg> or <span> inside the button, so
         walk up. Guarded because a target is not always an Element. */
      var el = e.target;
      if (!el || typeof el.closest !== 'function') return;
      var t = el.closest('[data-chat-trigger],[data-action="open-chat"]');
      if (!t) return;
      e.preventDefault();   // stop the href="#" jumping the page to the top
      if (isOpen) { input.focus(); return; }
      openPanel(true);
    });

    input.addEventListener('input', function () { sendBtn.disabled = !input.value.trim(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); send(); }
    });
    sendBtn.addEventListener('click', send);

    /* A session survives reloads and navigation: if the panel was open when the
       customer left the page, reopen it silently — no reconnect delay, no repeat
       greeting, since the conversation is already underway. */
    recordView();
    /* On EVERY page load, not only when a message is sent: by the time someone
       types, the referrer reads as our own site and the ?utm_/gclid parameters
       are several navigations behind them. Captured here, kept for the visit. */
    arrival();
    startHeartbeat();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) heartbeat();     // back in front: say so at once
      else farewell();                       // tab in the background is not "on the page"
    });
    /* pagehide, not unload: Safari never fires unload reliably, and unload
       disqualifies the page from the back/forward cache. */
    window.addEventListener('pagehide', farewell);
    loadPageProduct();

    if (wasOpen) {
      openPanel(transcript.length === 0);
    }
    /* Whether or not the panel was left open: an answer that was interrupted is
       still owed, and the badge should count it if they are not looking. */
    resumePending();

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        if (isOpen && window.innerWidth < 750) {
          panel.style.height = window.visualViewport.height + 'px';
          scrollLog();
        }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
